module.exports = __webpack_public_path__ + "Server-Warning.OfflineDrop.f86f891af56a4a2bbf0a3b433d1a0661.hashedasset.svg";